import React from "react";
import ProductPage from "./ProductPage";
import image from "../Images/product-heroes/attendance-hero.png";
import detailImage from "../Images/dashboards/employee-dashboard.png";

const product = {
  "id": "attendance",
  "title": "Attendance Management",
  "headline": "Know who is working.",
  "accent": "Keep every hour connected.",
  "description": "Track attendance across office, field and remote teams. Connect check-ins, shifts and leave with the information your HR and payroll teams need.",
  "checks": [
    "Real-time attendance",
    "Flexible shifts",
    "Mobile check-in"
  ],
  "badge": "A clear view of your workforce",
  "imageAlt": "Illustration of an employee checking in with a mobile attendance system",
  "summary": [
    {
      "icon": "clock",
      "title": "Connected time tracking",
      "text": "Bring daily attendance into one view."
    },
    {
      "icon": "mobile",
      "title": "Built for flexible teams",
      "text": "Support office, field and remote work."
    },
    {
      "icon": "wallet",
      "title": "Payroll-ready records",
      "text": "Connect attendance with salary processing."
    }
  ],
  "featuresTitle": "Attendance tools for the way your team works",
  "featuresSubtitle": "Keep time tracking, policies and workforce insights together.",
  "features": [
    {
      "title": "Time tracking",
      "icon": "clock",
      "text": "Capture attendance using the tools your workforce already uses.",
      "points": [
        "Biometric integration",
        "RFID and mobile attendance",
        "Real-time attendance synchronization"
      ]
    },
    {
      "title": "Shifts & attendance policies",
      "icon": "calendar",
      "text": "Set attendance rules around your working schedules.",
      "points": [
        "Rotational and night shifts",
        "Late and early departure calculations",
        "Overtime tracking"
      ]
    },
    {
      "title": "Mobile & location check-in",
      "icon": "mobile",
      "text": "Give field and remote employees a practical way to mark attendance.",
      "points": [
        "GPS-enabled mobile check-in",
        "Geofencing for work locations",
        "Attendance irregularity alerts"
      ]
    },
    {
      "title": "Leave & payroll connection",
      "icon": "wallet",
      "text": "Keep workforce records connected to the payroll cycle.",
      "points": [
        "Attendance and leave synchronization",
        "Salary calculation inputs",
        "Shared HR and payroll records"
      ]
    },
    {
      "title": "Attendance reports",
      "icon": "chart",
      "text": "Find patterns in daily attendance and working hours.",
      "points": [
        "Attendance trend dashboards",
        "Customizable reports",
        "Workforce planning insights"
      ]
    },
    {
      "title": "Workforce visibility",
      "icon": "people",
      "text": "Help managers understand attendance across their teams.",
      "points": [
        "Absence and overtime overview",
        "Clear employee attendance records",
        "Information for staffing decisions"
      ]
    }
  ],
  "detailImageAlt": "BillPunch employee dashboard showing monthly attendance and attendance rate",
  "detailLabel": "Visibility for Everyone",
  "detailTitle": "One attendance view. Fewer follow-ups.",
  "detailText": "Give employees access to their attendance history while HR teams review trends, shifts and time-off records in a connected workspace.",
  "detailPoints": [
    "Personal attendance overview",
    "Monthly time and attendance records",
    "Attendance and leave information together"
  ],
  "workflowTitle": "From daily check-in to workforce insights",
  "steps": [
    [
      "Set attendance policies",
      "Configure locations, shifts and working hours."
    ],
    [
      "Connect your tracking tools",
      "Set up biometric, RFID or mobile attendance."
    ],
    [
      "Track and review",
      "Monitor check-ins, absences and overtime."
    ],
    [
      "Connect to payroll",
      "Use attendance records in reports and salary processing."
    ]
  ],
  "cta": "Bring clarity to your attendance tracking."
};
product.image = image;
product.detailImage = detailImage;

const Attendance = () => <ProductPage product={product} />;

export default Attendance;
